
import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { images } from '@/assets/images';

interface BrochurePageProps {
  children: React.ReactNode;
  className?: string;
}

export const BrochurePage: React.FC<BrochurePageProps> = ({ children, className }) => {
  return (
    <motion.section
      className={cn(
        "w-full py-6 md:py-8 lg:py-12 px-4 sm:px-6 md:px-8 flex items-center justify-center",
        className
      )}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.5 }}
    >
      <div className="w-full max-w-6xl mx-auto space-y-8 md:space-y-12">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          className="flex justify-center"
        >
          <img 
            src={images.equiforgeLogoFlat} 
            alt="EquiForge Logo"
            className="h-10 md:h-12 lg:h-14 w-auto mx-auto mb-4 object-contain transition-all duration-300"
            loading="lazy"
          />
        </motion.div>
        {children}
      </div>
    </motion.section>
  );
};
